export const getLocale = (language) => {
    return language === 'en' ? '/en' : ''
}
